export default "__VITE_ASSET__Bi1y0amV__"